import { Checkbox } from "shared/components/Checkbox"
import { SettingRow, SettingWrapper } from "./style"
import { useEffect, useState } from "react"
import { Loader } from "shared/components/Loader";
import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";
import { getNotifications } from "../api/getNotifications";
import { IPropsNotificationsList, NotificationKeysList } from '../types'
import { patchNotifications } from "../api/patchNotifications";
import { Button } from "shared/components/Button";
import { toast } from "sonner";

const notificationList: NotificationKeysList = [
    {
        name: 'Уведомления',
        key: 'notifications',
    },
    {
        name: 'Акции',
        key: 'promotion',
    },
    {
        name: 'Отмена брони',
        key: 'booking_cansel',
    },
    {
        name: 'Освободилось время',
        key: 'time_freed_up',
    },
    {
        name: 'Новое бронирование',
        key: 'new_booking',
    },
    {
        name: 'Изменение бронирования',
        key: 'change_booking',
    },
]

export const SettingNotifications = () => {
    const [notificationMethods, setNotificationMethods] =
        useState<IPropsNotificationsList | null>(null)

    const { isLoading, data } = useQuery({
        queryKey: ['getNotifications'],
        queryFn: () => {
            return getNotifications()
        },
        placeholderData: keepPreviousData,
        retry: 3,
    })

    useEffect(() => {
        if (data && !notificationMethods) {
            setNotificationMethods(data.notifications)
        }
    }, [data]);
    
    const handleCheckboxChange = (key: keyof IPropsNotificationsList, index: number) => {
    setNotificationMethods((prev) => {
        if (!prev) return prev;

        const updated = { ...prev };
        const directions = [...updated[key].notification_directions];
        directions[index] = !directions[index];
        updated[key] = { ...updated[key], notification_directions: directions };

        const isTogglingOnInNotifications = key === "notifications" && directions[index] === true;

        if (isTogglingOnInNotifications) {
            for (const k in updated) {
                if (k === "notifications") continue;
                updated[k as keyof IPropsNotificationsList].notification_directions[index] = true;
            }
        }

        mutation.mutate(updated);
        return updated;
    });
};


    const mutation = useMutation({
        mutationFn: patchNotifications,
        onSuccess: () => {
            toast.success("Уведомления обновлены");
        },
        onError: (error) => {
            toast.error("Ошибка обновления уведомлений");
            console.error("Ошибка при обновлении уведомлений:", error);
        }
    });

    if(isLoading) {
        return <Loader />
    }

    return (
        <SettingWrapper>
            <div className='title'>Настройки уведомлений</div>
            {!isLoading && data && notificationMethods && (
                <SettingRow>
                    {notificationList.map((item, index) => {
                        const isEmailActive = notificationMethods.notifications.notification_directions[0];
                        const isTelegramActive = notificationMethods.notifications.notification_directions[1];

                        const isMainNotification = item.key === "notifications";

                        return (
                            <div key={index} className="notificationBlock">
                                <div className="notificationBlock__title">{item.name}</div>
                                <div className="notificationBlock__checkbox-list">
                                    <label
                                        className={!isEmailActive && !isMainNotification ? "disabled" : ""}
                                    >
                                        Email
                                        <Checkbox
                                            disabled={!isEmailActive && !isMainNotification ? true: false}
                                            name="checkbox" 
                                            checked={notificationMethods[item.key as keyof IPropsNotificationsList]?.notification_directions[0]} 
                                            onChange={() => handleCheckboxChange(item.key as keyof IPropsNotificationsList, 0)} />
                                    </label>
                                    <label className={!isTelegramActive && !isMainNotification ? "disabled" : ""}>
                                        Telegram
                                        <Checkbox 
                                            disabled={!isTelegramActive && !isMainNotification ? true: false}
                                            name="checkbox" 
                                            checked={notificationMethods[item.key as keyof IPropsNotificationsList]?.notification_directions[1]} 
                                            onChange={() => handleCheckboxChange(item.key as keyof IPropsNotificationsList, 1)} />
                                    </label>
                                </div>
                            </div>
                        )
                    })}
                    {data.telegram_link && <a className="btn-telegram" href={data.telegram_link} target="_blank" rel="noreferrer"><Button>Подключить Telegram</Button></a>}
                </SettingRow>
            )}
        </SettingWrapper>
    )
}
